import { gql } from '@apollo/client';

const DEVICES_FOR_STUDY_CREATION_QUERY = gql`
  query devicesForStudyCreation($filter: CallCenterDeviceFilterInput, $limit: Int) {
    callCenterDevices(filter: $filter, limit: $limit) {
      id
      deviceId
      status
      model
      canRunBiotresMCT
      additionalStatus
      isRenewal
      shouldMaintain
      isRunningStudy
      lastSync {
        operator
        schema
        gprs
      }
      facility {
        id
        status
      }
    }
  }
`;

export default DEVICES_FOR_STUDY_CREATION_QUERY;
